import actionTypes from '../../actions/actionTypes';
import updateObject from '../../../utils/updateObject.js';
import { menuItemType } from '../../../utils/menu';
import i18n from '../../../i18n/i18n';

const initialState = {
  menu: [
    { name: 'Account setup', path: '/', type: menuItemType.link, icon: 'user-circle'}
  ],
  isReady: false,
  error: null,
  title: 'Account'
};

function setDocumentTitle(title) {
  document.title = `${i18n.t(title)} | 11pets: Account`;
}

const initMenu = (state, action) => {
  return updateObject(state, {
    menu: action.menu,
    isReady: true
  });
}

const errored = (state, action) => {
  return updateObject(state, {
    menu: [],
    error: action.error
  });
}

const setTitle = (state, action) => {
  setDocumentTitle(action.title);
  return updateObject(state, {
    title: action.title
  });
}

const refreshTitle = (state, action) => {
  setDocumentTitle(state.title);
  return state;
}

export default function reducer(state = initialState, action) {
  switch(action.type) {
    case actionTypes.navigation.INIT_MENU:
      return initMenu(state, action);
    case actionTypes.navigation.ERRORED:
      return errored(state, action);
    case actionTypes.navigation.SET_TITLE:
      return setTitle(state, action);
    case actionTypes.navigation.REFRESH_TITLE:
      return refreshTitle(state, action);
    default:
      return state;
  }
}